<template>
    <!-- 下载 -->
    <div class="">
      <v-dialog
      class="del"
        name="dialog2"
        v-model="isShow"
        :title="dialogTitle"
        close-on-click-modal
        :modal="true"
        :width="668"
        :height="274"
        @after-close="handleAfterClose"
        @confirm="handleConfirm"
        append-to-body
        v-bind:confirmButtonText= "this.delete"
      >
        确定下载此文件吗？
      </v-dialog>
    </div>
</template>

  <script>
  export default {
    components: {},
    props:{
      showInputDialog:{
        type:Boolean,
        default: false
      },
      url: {
      }
    },
    data() {
      return {
        delete:"确定",
        dialogTitle: "下载文件",
        isShow:false,
      };
    },
    created() {
    },
    watch:{
      showInputDialog(newVal){
        this.isShow = newVal
      }
    },
    methods: {
      handleConfirm() {
        // window.open(this.url)
        let url = this.url
        let list = this.url.split('/')
        let name = list[list.length - 1]
        // 发送http请求，将文件链接转换成文件流
        let xhr = new XMLHttpRequest()
        xhr.open('get', url, true)
        // 请求类型
        xhr.responseType = 'blob'
        xhr.onreadystatechange = function() {
        	// 获取接口结果
            if (xhr.readyState === 4 && xhr.status === 200) {
              window.URL = window.URL || window.webkitURL
              let a = document.createElement('a')
              let blob = new Blob([xhr.response])
              // 通过二进制文件创建url
              let url = window.URL.createObjectURL(blob)
              a.href = url
              a.download = name
              a.click()
              // 销毁创建的url
              window.URL.revokeObjectURL(url)
            }
        }
        xhr.send()

      this.$emit('update:showInputDialog',false)
      },
      handleAfterClose() {
        this.$emit('update:showInputDialog',false)
      },
    },
    beforeDestroy() {},
  };
  </script>

  <style lang="scss">
  </style>
